import _ from 'lodash';
import EventEmitter from 'eventemitter3';

interface ModalProps {
  callback?: (payload: any) => void;
  closeButton?: boolean;
  dialogClass?: string;
  headerClass?: string;
  hideFooter?: boolean;
  hidePrint?: boolean;
  icon?: string;
  id?: string;
  message?: string | JSX.Element;
  meta?: any;
  onClose?: (params: any) => void;
  render?: string;
  size?: 'sm' | 'md' | 'lg';
  staticBackdrop?: boolean;
  style?: 'center' | 'fitted' | string;
  title?: string;
}

// Guessing these go together
interface ModalItemProps extends ModalProps {
  action?: 'edit' | 'new';
  contextName?: string;
  itemId?: string;
  itemName?: string;
  lookupKey?: string;
  [key: string]: any;
}

interface ModalCloseParams {
  skipOnClose?: boolean;
}

interface ModalEmitterActions {
  alert: (typeOrOptions: ModalItemProps | string, options?: ModalItemProps) => void;
  close: (options?: ModalCloseParams) => void;
  closeAll: () => void;
  config: object;
  confirm: (typeOrOptions: ModalItemProps | string, options?: ModalItemProps) => void;
  defaultIcon: string;
  info: (typeOrOptions: ModalItemProps | string, options?: ModalItemProps) => void;
  open: (typeOrOptions: ModalItemProps | string, options?: ModalItemProps) => void;
}

const emitter = new EventEmitter();

const confirmDefaults = {
  headerClass: 'bg-default',
  hidePrint: true,
  render: 'confirm',
  size: 'sm',
  staticBackdrop: true,
  style: 'center',
  title: 'Confirm',
};

const alertDefaults = {
  headerClass: 'yellow',
  hidePrint: true,
  render: 'alert',
  size: 'sm',
  style: 'center',
  title: 'Alert',
};

const infoDefaults = {
  headerClass: 'primary',
  hidePrint: true,
  render: 'info',
  size: 'lg',
  style: 'center',
  title: 'Info',
};

const actions: ModalEmitterActions = {
  config: {},
  defaultIcon: 'fad fa-th-list',
  open: (type, args) => {
    if (_.isString(type)) {
      emitter.emit('modal/open', type, populateOptions(type, args));
    } else {
      emitter.emit('modal/open', 'info', type);
    }
  },
  confirm: (...args) => {
    const options = typeof args[0] === 'string' ? { message: args[0] } : args[0] || {};
    emitter.emit('modal/confirm', _.defaults(options, confirmDefaults));
  },
  alert: (...args) => {
    const options = typeof args[0] === 'string' ? { message: args[0] } : args[0] || {};
    emitter.emit('modal/alert', _.defaults(options, alertDefaults));
  },
  info: (...args) => {
    const options = typeof args[0] === 'string' ? { message: args[0] } : args[0] || {};
    emitter.emit('modal/info', _.defaults(options, infoDefaults));
  },
  close: args => {
    emitter.emit('modal/close', args);
  },
  closeAll: () => {
    emitter.emit('modal/closeAll');
  },
};

const populateOptions = (type = '', options= {}) => {
  if (type === 'listEditItem') {
    return { ...editFormDialog, ...options };
  }

  return options;
};

export const editFormDialog = {
  action: 'edit',
  dialogClass: 'fitted',
  headerClass: 'primary',
  hideFooter: true,
  hidePrint: true,
};

export const EE = emitter;
export const modal = actions;
